import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import Tooltip from "./../../wix-rich-content-common/lib/Tooltip";
import styles from "../statics/styles/widget.scss";
const subtitle = (info) => {
  return info.leftSubtitle && /* @__PURE__ */ React.createElement("div", { className: styles.subtitle }, info.leftSubtitle, info.rightSubtitle && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", { className: styles.right }, "|"), info.rightSubtitle));
};
const ellipsisTitle = (title) => {
  return title.length <= 80 ? title : `${title.substring(0, 80)}...`;
};
const CardContent = (props) => {
  const { title, info, buttonText, disabled, t } = props;
  return /* @__PURE__ */ React.createElement("div", { className: styles.content }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: styles.title }, ellipsisTitle(title)), info && subtitle(info)), /* @__PURE__ */ React.createElement(Tooltip, { content: disabled ? t("VerticalEmbed_Disabled_Button_Tooltip") : null }, /* @__PURE__ */ React.createElement("div", { className: classNames(styles.button, { [styles.button_disabled]: disabled }) }, /* @__PURE__ */ React.createElement("div", { className: styles.buttonText }, buttonText))));
};
CardContent.propTypes = {
  title: PropTypes.string.isRequired,
  info: PropTypes.object,
  buttonText: PropTypes.string.isRequired,
  disabled: PropTypes.string.boolean,
  t: PropTypes.func.isRequired
};
var CardContent_default = CardContent;
export {
  CardContent_default as default
};
//# sourceMappingURL=CardContent.js.map
